import currencyUtils from '@utils/currencyUtils';
import numberFormat from './numberFormat';
import { numberConstants } from '@/utils/constants';

/**
 * Currency value for 'en-US' locale plus the currency value
 * Example:
 * - 1000 Canadian Dollars: $100
 * - 1000 US Dollars: $100
 * - 1000 Euro: E100
 * @param {Number} value
 * @param {String} currency
 * @param {Object} options
 */
export default function currencySimpleFilter(
    value,
    currency,
    opts = { format: numberConstants.FORMAT.DEFAULT, showZero: true }
) {
    const options = Object.assign(
        {
            format: numberConstants.FORMAT.DEFAULT,
            showZero: true,
        },
        opts
    );
    const { format, showZero, ...optionsRest } = options;
    if (!showZero && !+value) {
        return '';
    }
    try {
        if (!currency) {
            return numberFormat(value, format);
        } else {
            const ret = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency,
                ...optionsRest,
            }).format(value);
            const symbol = currencyUtils.getSymbol(currency);
            const arrayRet = ret.split(symbol);

            if (arrayRet.length > 1) {
                if (value >= 0) {
                    return `${symbol}${arrayRet[1]}`;
                } else {
                    return `-${symbol}${arrayRet[1]}`;
                }
            } else {
                return `${ret}`;
            }
        }
    } catch {
        return numberFormat(value);
    }
}
